import { createContext } from "react";

/** Tells the controller's step-advance watch that Next pressed this step's opener; null when no tour runs. */
export const WalkthroughNextOpensContext = createContext<((index: number) => void) | null>(null);
